import { Input, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@devhop/ui";
import { Search } from "lucide-react";

export type EmployeeProfileSearchParams = {
  search?: string;
  branch?: string;
  status?: string;
  departmentId?: string;
  offset?: number;
  limit?: number;
};

type Props = {
  searchParams: EmployeeProfileSearchParams;
  onSearchChange: (params: Partial<EmployeeProfileSearchParams>) => void;
};

const STATUS_OPTIONS = [
  { value: "active", label: "ຍັງເຮັດວຽກ" },
  { value: "probation", label: "ທົດລອງງານ" },
  { value: "probation_failed", label: "ບໍ່ຜ່ານທົດລອງ" },
  { value: "resigned", label: "ລາອອກ" },
  { value: "terminated", label: "ຖືກເລີກຈ້າງ" },
];

const BRANCH_OPTIONS = [
  { value: "HQ", label: "HQ — ສຳນັກງານໃຫຍ່" },
  { value: "PTB", label: "PTB" },
  { value: "DDB", label: "DDB" },
];

export function EmployeeProfileFilter({ searchParams, onSearchChange }: Props) {
  return (
    <div className="flex flex-wrap gap-3 p-4">
      <div className="relative min-w-[220px] flex-1">
        <Search className="absolute top-2.5 left-3 size-4 text-muted-foreground" />
        <Input
          placeholder="ຄົ້ນຫາ ຊື່ / ລະຫັດ / ອີເມວ..."
          className="pl-9"
          value={searchParams.search ?? ""}
          onChange={(e) =>
            onSearchChange({ search: e.target.value || undefined, offset: 0 })
          }
        />
      </div>

      <Select
        value={searchParams.status ?? "all"}
        onValueChange={(v) =>
          onSearchChange({
            status: v === "all" ? undefined : v,
            offset: 0,
          })
        }
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="ສະຖານະທັງໝົດ" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">ສະຖານະທັງໝົດ</SelectItem>
          {STATUS_OPTIONS.map((o) => (
            <SelectItem key={o.value} value={o.value}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={searchParams.branch ?? "all"}
        onValueChange={(v) =>
          onSearchChange({
            branch: v === "all" ? undefined : v,
            offset: 0,
          })
        }
      >
        <SelectTrigger className="w-[160px]">
          <SelectValue placeholder="ສາຂາທັງໝົດ" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">ສາຂາທັງໝົດ</SelectItem>
          {BRANCH_OPTIONS.map((o) => (
            <SelectItem key={o.value} value={o.value}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
